import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PaymentSuccessData {
  isSuccess: boolean;
  featureType?: string | undefined;
  amount?: number | undefined;
}

export const usePaymentSuccess = (): PaymentSuccessData => {
  const [paymentSuccess, setPaymentSuccess] = useState<PaymentSuccessData>({ isSuccess: false });
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const isSuccess = urlParams.get('payment_success') === 'true';
    
    if (isSuccess) {
      const featureType = urlParams.get('feature') || undefined;
      const amount = urlParams.get('amount') ? parseFloat(urlParams.get('amount')!) : undefined;
      
      setPaymentSuccess({
        isSuccess: true,
        featureType,
        amount
      });

      // Clean up URL parameters after detecting success
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('payment_success');
      newUrl.searchParams.delete('feature'); 
      newUrl.searchParams.delete('amount');
      window.history.replaceState({}, '', newUrl.toString());
    } else {
      setPaymentSuccess({ isSuccess: false });
    }
  }, [location.search]);

  return paymentSuccess;
};

export default usePaymentSuccess;